import React from "react"
import Select from "react-select"
import { customSelectStyles } from "./styles"

const CustomSelect = ({ options, value, onChange, ...props }) => {
    return <Select styles={customSelectStyles} value={value} onChange={onChange} options={options} {...props} />
}

export default CustomSelect
